import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledBannerWrapper = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--banner-wrapper-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--banner-wrapper-bounds-right': props.$wrapper?.boundsCum?.right ?? '0px',
      '--banner-wrapper-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px',
      '--banner-wrapper-bounds-left': props.$wrapper?.boundsCum?.left ?? '0px',
      '--banner-wrapper-width': props.$width
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  min-height: calc(100vh - (${props => props.$css.$var('--banner-wrapper-bounds-top')} + ${props => props.$css.$var('--banner-wrapper-bounds-bottom')}));
  width: calc(100vw - (${props => props.$css.$var('--banner-wrapper-bounds-left')} + ${props => props.$css.$var('--banner-wrapper-bounds-right')}));
  
  .BannerWrapper {
    &-banner {
      position: fixed;
    }
    
    &-content {
      display: flex;
      justify-content: center;
      align-items: center;
      
      flex-grow: 1;
      z-index: 1;
      
      > * {
        width: ${props => utils.isDefined(props.$width) ? props.$css.$var('--banner-wrapper-width', false) : null};
        min-width: ${props => utils.isDefined(props.$width) ? props.$css.$var('--banner-wrapper-width', false) : null};
        height: unset;
        min-height: unset;

        ${props => props.theme.breakpoints.down('sm')} {
          width: 100%;
          min-width: 100%;
        }
      }
    }
  }

  ${props => props.theme.breakpoints.down('md')} {
    .BannerWrapper {
      &-banner {
        position: absolute;
      }

      &-content {
        margin-left: 0 !important;
        padding: 0 ${props => props.theme.spacing(7)};  
      }
    }
  }
  
  ${ComponentStyles}
`;

export default StyledBannerWrapper;
